<template lang="pug">
main
  //- Hero
  BannerEmpresa

  div(v-if="!EMPRESA.bodegas")
    //- Sticky Nav
    nav.sticky-nav
      .container
        ul#stickyNavItems
          li(v-for="n in CATEGORIAS" :key="n.id")
            a.list-group-item.sticky-nice-scroll(:href='`#section${n.id}`' @click="navegarCategoria(`#section${n.id}`, $event)") #[i.bi.bi-tag] {{ n.nombre }}
      span

    //- Main
    .order
      .container.pb-5
        .row
          ListaProductos
  div(v-else)
    //- Main Bodegas
    main
      .services
        .container
          .main-title
            span: em
            h2 Sucursales
            p Seleccione una sucursal para mirar la carta

          .row
            .col-lg-6.animated-element(v-for="bodega in BODEGAS" :key="bodega.id")              
              router-link.service-link(:to="`/${$store.state.DATA_BASE}/warehouse/${bodega.id}`")
                .box.text-center
                  .icon.d-flex.align-items-center.justify-content-center: i.bi.bi-shop
                  h3.service-title {{bodega.nombre}}
                  //- p and wait for delivery
            
</template>

<script>
import ListaProductos from '@/components/ListaProductos.vue';
import BannerEmpresa from '@/components/BannerEmpresa.vue';

import { mapState } from 'vuex';

export default {
  name: 'HomeView',
  components: {
    BannerEmpresa,
    ListaProductos,
  },

  computed: {
    ...mapState(['CATEGORIAS', 'EMPRESA', 'BODEGAS'])
  },

  methods: {
    navegarCategoria(hash, event) {
      event.preventDefault()
      const posicion = $(hash).offset().top - 140;
      window.scrollTo(0, posicion)
    }
  }
}
</script>
